// Brand colours: the single source for the theme and for code that styles by hand
export const colors = {
    primary    : '#3179FF', // brand blue (logo dot, buttons, links)
    primaryTint: '#EAF2FF', // pale primary for selected / highlighted backgrounds
    titleBlue  : '#324483', // navy headings
    dividerBlue: '#DEEEFF',
    textDark   : '#171725',
    textGrey   : '#585D72',
    subtitleGrey: '#717480',
};

/* Account layout widths.
   contentMaxWidth: single-column pages are centered and capped at this (PageContainer); 'none' turns it off.
   shellMaxWidth: guard for very wide screens: the whole account area (rail + content, including the
   full-width customer dashboard) is centered and capped at this (AccountShell). 2560 keeps 27" screens as they are.
   readingWidth: chat threads. */
export const layout = {
    contentMaxWidth: 1440 as number | 'none',
    shellMaxWidth: 2560 as number | 'none',
    readingWidth: 760,
};

export const fontFamily = 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif';
